<template>
  <div class="PruebaChatbot">
    <div class="PruebaChatbot__canvas">
      <p class="PruebaChatbot__hint">Página de prueba del chatbot (ignora el flag de activación)</p>
      <ChatbotWidget :start-open="true" />
    </div>
  </div>
</template>

<script>
import ChatbotWidget from '@/components/widgets/ChatbotWidget/ChatbotWidget';

export default {
  name: 'PruebaChatbot',
  metaInfo: {
    title: 'Prueba chatbot',
  },
  components: {
    ChatbotWidget,
  },
};
</script>

<style lang="scss" src="./PruebaChatbot.scss"></style>
